
import Vue from "vue";
import AppTotal from "@/components/cashier/CashierTotal.vue";
import AppGroups from "@/components/cashier/CashierGroups.vue";
import AppProducts from "@/components/cashier/CashierProducts.vue";
import {SaleEditState} from "@/utils/sale-edit/sale-edit-state";
import {DossierConfigService, SaleService, UserConfigService} from "@/services";
import {Sale} from "@/models/base";
import {CashierButtonConfig} from "@/models/dossier-configs/cashier";

export default Vue.extend({
	data(){
		return {
			activeGroupID: 0,
			width: window.innerWidth,
			state: new SaleEditState(this, 1),
			settings: UserConfigService.getCashierSettings(),
			config: null as null | CashierButtonConfig
		};
	},
	methods: {
		updateGroup(id: number){
			this.activeGroupID = id;
		},
		async saveConfig(config: CashierButtonConfig){
			this.config = await DossierConfigService.setCashierButtonsConfig(config);
		},
		onSaleSaved(sale: Sale){
			this.state.sale = sale;
		},
		async initSale(){
			let allSaleTypes = SaleService.getTypes(1);
			let defaultSaleType = this.settings.DefaultSaleType || 9;

			let saleType = allSaleTypes.find(s=>s.ID == defaultSaleType);
			if (saleType){
				this.state.sale.Type = saleType;
				this.state.sale.TypeID = saleType.ID;
			}else{
				this.state.sale.Type = allSaleTypes[0];
				this.state.sale.TypeID = allSaleTypes[0].ID;
			}
			let defaultContactID = this.state.sale.getDefaultContactID();
			if (defaultContactID && this.state.sale.ContactID == 0) {
				let c = await this.state.getContactService().getContact(defaultContactID);
				await this.state.selectContact(c);
			}
			this.state.productEditRowState.contactDiscount = 0;
		},
		onResize() {
			this.width = window.innerWidth;
		}
	},
	async created(){
		this.config = await DossierConfigService.getCashierButtonConfig();
		await this.initSale();
		this.state.on("saved", this.onSaleSaved);
		window.addEventListener("resize", this.onResize);
	},
	destroyed() {
		this.state.off("saved", this.onSaleSaved);
		window.removeEventListener("resize", this.onResize);
	},
	components: {
		AppGroups,
		AppProducts,
		AppTotal
	}
});
